import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
    providedIn: 'root',
})
export class MicrosoftAttachmentService {
    constructor(private httpClient: HttpClient) {}

    getAttachments(accessToken: string, messageId: string): Observable<any> {
        return this.httpClient.get<any>(
            'https://graph.microsoft.com/v1.0/me/messages/' + messageId + '/attachments?$top=100',
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + accessToken,
                }),
            },
        );
    }
}
